import React from "react";
import { motion } from "framer-motion";
import { CLINIC } from "../lib/clinic";

const credentials = [
  "Founder of restore.dental",
  "500+ Invisalign cases",
  "15+ years clinical experience",
  "Cosmetic & restorative specialist",
  "Trained in TMJ & facial aesthetics",
  "5.0★ Google rated",
];

export const AboutDoctor = () => {
  return (
    <section data-testid="about-section" className="py-24 lg:py-32 bg-rb-bg">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="lg:col-span-5 relative"
        >
          <div className="absolute -top-8 -left-6 w-32 h-32 rounded-full bg-[#93C5FD]/15 blur-3xl" />
          <div className="relative rounded-[28px] overflow-hidden border border-rb-border">
            <img
              src="https://images.unsplash.com/photo-1729162128021-f37dca3ff30d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHxoYW5kc29tZSUyMG1hbGUlMjBkZW50aXN0JTIwZG9jdG9yJTIwcG9ydHJhaXR8ZW58MHx8fHwxNzc4MzU1MzcxfDA&ixlib=rb-4.1.0&q=85"
              alt={`Portrait of ${CLINIC.doctor.name}`}
              className="w-full h-[560px] object-cover"
            />
          </div>
        </motion.div>

        <div className="lg:col-span-7">
          <div className="font-overline mb-4">Your dentist</div>
          <h2 className="font-serif-display text-3xl sm:text-4xl lg:text-5xl text-rb-text leading-[1.1]">
            {CLINIC.doctor.name}
          </h2>
          <p className="mt-3 text-rb-text-2">{CLINIC.doctor.credentials}</p>

          <p className="mt-7 text-rb-text-2 leading-relaxed text-lg">
            {CLINIC.doctor.bio}
          </p>

          <blockquote className="mt-8 border-l-2 border-[#93C5FD] pl-6 italic font-serif-display text-2xl text-rb-text">
            "I approach every patient with one question:{" "}
            <span className="not-italic text-[#93C5FD]">
              what would I want for my own family?
            </span>{" "}
            That guides every decision — from the materials we use to the time
            we invest getting things right."
          </blockquote>
          <div className="mt-3 text-sm text-rb-text-2">— Dr. Kartik Patel</div>

          <div className="mt-10 grid grid-cols-2 sm:grid-cols-3 gap-3">
            {credentials.map((c, i) => (
              <div
                key={c}
                data-testid={`credential-${i}`}
                className="bg-white/5 border border-white/10 rounded-full px-4 py-2 text-xs text-rb-text text-center"
              >
                {c}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
